// import React from "react";
// import { LuCake } from "react-icons/lu";
// import { FaStar } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import "./UpcomingBookings.css";

// const UpcomingBookings = () => {
//   const navigate = useNavigate();

//   const bookings = [
//     {
//       id: 1,
//       title: "Birthday Event",
//       date: "15 Dec, 2025",
//       day: "Monday",
//       rating: 5,
//       status: "Completed",
//       amount: "Rs. 7,000/-",
//     },
//     {
//       id: 2,
//       title: "Birthday Event",
//       date: "15 Dec, 2025",
//       day: "Monday",
//       rating: 5,
//       status: "Completed",
//       amount: "Rs. 7,000/-",
//     },
//     {
//       id: 3,
//       title: "Birthday Event",
//       date: "15 Dec, 2025",
//       day: "Monday",
//       rating: 4,
//       status: "Completed",
//       amount: "Rs. 7,000/-",
//     },
//   ];

//   const handleViewDetails = (bookingId) => {
//     navigate("/bookingDetails", { state: { bookingId } });
//   };
//  const handleModifyBooking = (bookingId) => {
//     navigate("/modifyBooking" , {state: {bookingId}})
//   }

//   return (
//     <div className="booking-list">
//       {bookings.map((booking) => (
//         <div className="booking-card" key={booking.id}>
//           <div className="booking-left">
//             <h3 className="booking-title-upcoming">
//               <LuCake className="cake-icon" />
//               {booking.title}
//             </h3>

//             <p className="booking-date">
//               {booking.date} &nbsp; <span>{booking.day}</span>
//             </p>

//             <div className="booking-rating">
//               <span className="rating-label">Ratings</span>
//               <div className="stars">
//                 {[...Array(booking.rating)].map((_, index) => (
//                   <FaStar key={index} />
//                 ))}
//               </div>
//             </div>

//            <div className="booking-actions" >
//               <button className="modify-btn" onClick={() => handleModifyBooking(booking.id)}>Modify</button>

//               <button
//                 className="view-details"
//                 onClick={() => handleViewDetails(booking.id)}
//               >
//                 View Details
//               </button>
//             </div>

//           </div>

//           <div className="booking-right">
//             <span className="status completed">{booking.status}</span>
//             <p className="amount">{booking.amount}</p>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default UpcomingBookings;



import React, { useEffect, useState } from "react";
// import { LuCake } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import "./UpcomingBookings.css";
import Loader from "../../../../Template/Loader/Loader";
import { callAdminSupport, getAllUpcomingBookings } from "../../../../utils/APIs/bookingApis";
import OutstandingAmountModal from "../OutstandingAmoutModal/OutstandingAmountModal";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import CommonMessageModal from "../../../CommonMessageModal/CommonMessageModal";

const UpcomingBookings = () => {
  const navigate = useNavigate();

  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showOutstandingModal, setShowOutstandingModal] = useState(false);
  const [outstandingAmount, setOutstandingAmount] = useState(0);
  const [selectedBookingId, setSelectedBookingId] = useState(null);
  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState("");
  const [callingBookingId, setCallingBookingId] = useState(null);
  const [showCallMessage, setShowCallMessage] = useState(false);
  const [callMessage, setCallMessage] = useState("");


  /* =========================
     FETCH UPCOMING BOOKINGS
  ========================= */
  useEffect(() => {
    fetchUpcomingBookings();
  }, []);

  const fetchUpcomingBookings = async () => {
    try {
      setLoading(true);
      const response = await getAllUpcomingBookings();

      // ✅ API response: { success: true, data: [] }
      const apiBookings = response?.data?.data || [];

      setBookings(apiBookings);
    } catch (error) {
      console.error("Upcoming bookings error:", error);
      setBookings([]);
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     NAVIGATION
  ========================= */
  const handleViewDetails = (bookingId) => {
    sessionStorage.setItem("bookingMainTab", "upcoming");
    navigate(`/bookingDetails/${bookingId}?tab=details`);
  };

  const handleChatNow = (bookingId) => {
    navigate(`/bookingChat/${bookingId}`)
  };

  //  const handleGalleryNow = (bookingId) => {
  //   navigate(`/bookingDetails/${bookingId}?tab=gallery`);
  // };

  const handleGalleryNow = (booking) => {
    console.log("booking GALLERY", booking)
    navigate(
      `/bookingDetails/${booking._id}?tab=gallery`,
      {
        state: {
          photographerId: booking.photographer_id,
          clientId: booking.client_id,
        },
      }
    );
  };

  const handleCallAdmin = async (booking) => {
    if (!booking?._id || callingBookingId) return;

    try {
      setCallingBookingId(booking._id);
      const response = await callAdminSupport(booking._id);
      setCallMessage(
        response?.data?.message ||
          "Call initiated. You will receive a call on your registered mobile number."
      );
      setShowCallMessage(true);
    } catch (error) {
      setCallMessage(
        error?.response?.data?.message || "Unable to initiate call right now."
      );
      setShowCallMessage(true);
    } finally {
      setCallingBookingId(null);
    }
  };

  const normalizeBookingStatus = (booking) => {
    const raw = (booking?.status || booking?.bookingStatus || "").toString().trim();
    const normalized = raw.toLowerCase().replace(/[_-]+/g, " ").replace(/\s+/g, " ");

    const statusMap = {
      pending: "pending",
      accepted: "booking confirmed",
      confirmed: "booking confirmed",
      "booking confirmed": "booking confirmed",
      "shoot completed": "shoot completed",
      completed: "shoot completed",
      "payment confirmed": "payment confirmed",
      "fully paid": "payment confirmed",
      "gallery delivery": "gallery delivery",
      canceled: "canceled",
      cancelled: "canceled",
    };

    return statusMap[normalized] || normalized || "pending";
  };

  const capitalizeFirstLetter = (text = "") =>
    text.charAt(0).toUpperCase() + text.slice(1);

  /* =========================
     DATE FORMATTER
  ========================= */
  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const getDayFromDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("en-IN", {
      weekday: "long",
    });
  };

  /* =========================
     LOADER
  ========================= */
  if (loading) {
    return <Loader />;
  }

  return (
    <div className="booking-list">
      {bookings.length === 0 ? (
        <p className="no-data">No upcoming bookings found</p>
      ) : (
        bookings.map((booking) => (
          <div className="booking-card" key={booking._id}>
            <div className="booking-left">
              <div className="booking-left-top">
                <h3 className="booking-title-upcoming">
                  {(booking.service_id?.serviceName?.toLowerCase().includes("hourly") || booking.serviceCategory?.toLowerCase() === "hourly") && (
                    <>
                      {booking.eventType ? capitalizeFirstLetter(booking.eventType) : "Hourly Shoot"}
                      <span className="service-tag hourly" style={{ marginLeft: 0 }}>Hourly</span>
                      <span className="plan-tag" style={{ marginLeft: 0 }}>
                        {capitalizeFirstLetter(booking.subCategoryType || (booking.service_id?.serviceName?.toLowerCase().includes("premium") ? "premium" : "standard"))}
                      </span>
                    </>
                  )}
                  {(booking.service_id?.serviceName?.toLowerCase().includes("editing") || booking.serviceCategory?.toLowerCase() === "editing") && (
                    <>
                      <span className="service-tag editing">Editing</span>
                    </>
                  )}
                  {!booking.service_id?.serviceName?.toLowerCase().includes("hourly") && 
                  !booking.service_id?.serviceName?.toLowerCase().includes("editing") && 
                  booking.serviceCategory?.toLowerCase() !== "hourly" && 
                  booking.serviceCategory?.toLowerCase() !== "editing" && (
                    <>
                      {booking.eventType ? capitalizeFirstLetter(booking.eventType) : (booking.service_id?.serviceName || booking.serviceCategory || "Service")}
                    </>
                  )}
                </h3>

                <p className="booking-date">
                  {formatDate(booking.startDate || booking.date || booking.bookingDate)} &nbsp;
                  <span className="booking-day">
                    {getDayFromDate(booking.startDate || booking.date || booking.bookingDate)}
                  </span>
                </p>

                {normalizeBookingStatus(booking) === "gallery delivery" && (
                  <div className="booking-rating">
                    <span className="rating-label">Ratings</span>
                    <div className="stars">
                      {[...Array(5)].map((_, index) => {
                        const rating = booking.ratingsGivenByClient || 0;
                        if (rating >= index + 1) return <FaStar key={index} />;
                        else if (rating >= index + 0.5) return <FaStarHalfAlt key={index} />;
                        else return <FaRegStar key={index} />;
                      })}
                    </div>
                  </div>
                )}
              </div>

              <div className="status-tracker">
                <div className="status-line">
                  {(() => {
                    const bookingStatusLower = normalizeBookingStatus(booking);
                    const isCanceled = bookingStatusLower === "canceled" || bookingStatusLower === "cancelled";
                    const CURRENT_FLOW = isCanceled 
                      ? ["pending", "booking confirmed", "shoot completed", "payment confirmed", "gallery delivery", "canceled"]
                      : ["pending", "booking confirmed", "shoot completed", "payment confirmed", "gallery delivery"];

                    return CURRENT_FLOW.map((status, index) => {
                      const currentIndex = CURRENT_FLOW.indexOf(bookingStatusLower);
                      const isActive = isCanceled ? index < CURRENT_FLOW.length - 1 : index <= currentIndex;
                      const isCancelCircle = isCanceled && index === CURRENT_FLOW.length - 1;

                      return (
                        <React.Fragment key={status}>
                          <div className={`status-circle ${isActive ? "active" : ""} ${isCancelCircle ? "cancel" : ""}`}>
                            {isCancelCircle && <span className="cancel-cross">✕</span>}
                          </div>
                          {index < CURRENT_FLOW.length - 1 && (
                            <div className={`status-connector ${isActive ? "active" : ""}`} />
                          )}
                        </React.Fragment>
                      );
                    });
                  })()}
                </div>
                <span className="status-label">{capitalizeFirstLetter(normalizeBookingStatus(booking))}</span>
              </div>

              <div className="booking-actions">
                <button className="modify-btn" onClick={() => handleChatNow(booking._id)}>Chat Now</button>
                <button
                  className="modify-btn"
                  onClick={() => handleCallAdmin(booking)}
                  disabled={callingBookingId === booking._id}
                >
                  {callingBookingId === booking._id ? "Calling..." : "Call"}
                </button>
                <button className="modify-btn" onClick={() => handleGalleryNow(booking)}>Gallery</button>
                {(booking.service_id?.serviceName?.toLowerCase().includes("editing") || booking.serviceCategory === "editing") && (
                  <button className="modify-btn" onClick={() => navigate(`/upload-media?bookingId=${booking._id}`)}>Upload Media</button>
                )}
                <button className="view-details" onClick={() => handleViewDetails(booking._id)}>View Details</button>
              </div>
            </div>

            <div className="booking-right">

              {(() => {
                const totalAmount = Math.round(booking.finalAmount || booking.totalAmount || 0);
                const remainingAmount = Math.round(booking.outStandingAmount || 0);
                const paidAmount = totalAmount - remainingAmount;

                return (
                  <>
                    <div className="booking-right-top">
                      <span
                        className={`paymentStatus ${booking.paymentStatus}`}
                      >
                        {capitalizeFirstLetter(booking.paymentStatus)}
                      </span>

                      <div className="amount-breakdown">
                        <p className="amount total">
                          Total: ₹ {totalAmount}/-
                        </p>
                        <p className="amount paid">
                          Paid: ₹ {paidAmount}/-
                        </p>
                        {remainingAmount > 0 && (
                          <p className="amount remaining">
                            Remaining: ₹ {remainingAmount}/-
                          </p>
                        )}
                      </div>
                    </div>

                    {remainingAmount > 0 && (
                      <button
                        className="Pay-Outstanding_Amount"
                        onClick={() => {
                          setOutstandingAmount(remainingAmount);
                          setSelectedBookingId(booking._id);
                          setSelectedPaymentStatus(booking.paymentStatus);
                          setShowOutstandingModal(true);
                        }}
                        disabled={normalizeBookingStatus(booking) === "canceled"}
                      >
                        {booking.paymentStatus === "pending" ? "Pay Now" : "Pay Outstanding Amount"}
                      </button>
                    )}
                  </>
                );
              })()}
            </div>
          </div>
        ))
      )}
      <OutstandingAmountModal
        show={showOutstandingModal}
        bookingId={selectedBookingId}
        outstandingAmount={outstandingAmount}
        paymentStatus={selectedPaymentStatus} // Pass this
        onClose={() => setShowOutstandingModal(false)}
        onSuccess={() => {
          setShowOutstandingModal(false);
          fetchUpcomingBookings(); // refresh list
        }}
      />

      <CommonMessageModal
        show={showCallMessage}
        message={callMessage}
        onClose={() => setShowCallMessage(false)}
      />


    </div>
  );
};

export default UpcomingBookings;
